import type { HTMLAttributes } from 'react';
import { UiLegacy } from '@silvertours/front-legacy-shared';
import { Badge, InfoIcon, StyledTooltip } from './TooltipBadge.styles';

type TooltipBadgeProps = {
  badgeText: string;
  tooltipTitle: string;
  tooltipText: string;
  tooltipLabel?: string;
  onHover?: () => void;
} & Pick<HTMLAttributes<HTMLDivElement>, 'className'>;

const TooltipBadge = ({
  badgeText,
  tooltipTitle,
  tooltipText,
  tooltipLabel,
  onHover,
  className,
}: TooltipBadgeProps) => (
  <Badge className={className}>
    {badgeText}
    <StyledTooltip
      content={<UiLegacy.Markup content={tooltipText} />}
      title={tooltipTitle}
      width="wide"
      trigger={<InfoIcon onMouseEnter={onHover} />}
      aria-label={tooltipLabel}
    />
  </Badge>
);

export { TooltipBadge };
